import { ReactComponent as addColumn } from "assets/addColumn.svg";
import { useState } from "react";
import { ModalCreateColumn } from "pages/gdt/modals/ModalCreateColumn/ModalCreateColumn";
import { ButtonIconPermissioned } from "components/ButtonIconPermissioned/ButtonIconPermissioned";

export interface QuickActionAddColumnProps {
  tableId: string;
}
export const QuickActionAddColumn = ({
  tableId,
}: QuickActionAddColumnProps) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <ButtonIconPermissioned
        requiredPermission="edit"
        defaultTooltip="Insert column"
        aria-label="Insert column"
        size="xs"
        iconType={addColumn}
        onClick={() => setShowModal(true)}
        id={"quickActionInsertColumn"}
      />
      {showModal && (
        <ModalCreateColumn
          tableId={tableId}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};
